import React from "react";
import {
  FaUserFriends,
  FaShieldAlt,
  FaTrophy,
  FaCheckCircle,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import "../Know/Know.css";

const Know = () => {
  return (
    <div className="know-section">
      <div className="know-left">
        <div className="main-image">
          <img src="/couple.webp" alt="Travel" className="main-img" />
          <img src="/travel.webp" alt="Beach" className="img-bottom-left" />
          <img src="/beach.webp" alt="Luggage" className="img-bottom-right" />
          <img src="/discount.webp" alt="Discount" className="img-discount" />
        </div>
      </div>
      <div className="know-right">
        <p className="know-tag">GET TO KNOW US</p>
        <h1 className="know-heading">Discover the Joy of Seamless Travel</h1>
        <p className="know-desc">
          With years of experience and a passion for exploration, we curate
          unforgettable journeys for every kind of traveler. From exotic escapes
          to cultural adventures, we make your dream trips come true.
        </p>

        <div className="know-cards">
          <div className="know-card">
            <FaUserFriends className="card-icon" />
            <div className="card-content">
              <h3>Friendly Guides</h3>
              <p>
                Our local experts ensure every trip is insightful, fun, and
                memorable.
              </p>
            </div>
          </div>
          <div className="know-card">
            <FaShieldAlt className="card-icon" />
            <div className="card-content">
              <h3>Safe & Secure Travel</h3>
              <p>
                Your safety is our priority, with carefully planned routes and
                support.
              </p>
            </div>
          </div>
        </div>

        <div className="know-bottom">
          <div className="award-box">
            <FaTrophy className="award-icon" />
            <p>Award-Winning Travel Experts</p>
          </div>
          <div className="points">
            <p>
              <FaCheckCircle className="point-icon" /> Tailor-made itineraries
            </p>
            <p>
              <FaCheckCircle className="point-icon" /> 24/7 journey support
            </p>
            <p>
              <FaCheckCircle className="point-icon" /> Trusted by explorers.
            </p>
            <Link to="/destination">
              <button className="explore-btn">Explore More</button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Know;
